<template>
  <v-card class="mx-auto pb-10" max-width="1280">
    <v-card-text class="px-1 px-md-3 px-xl-6">
      <v-row class="home">
        <v-col :md="md_title" offset-md="3">
          <h1>{{ $t("drawer.main_menu") }}</h1>
          <p>Choose the system. ({{ privilege_name }})</p>
        </v-col>
        <v-col md="3" offset-md="3">
          <v-autocomplete
            v-model="privilege_id_test"
            label="มุมมองสิทธิ์การใช้งาน"
            v-bind:item-text="(item) => item.name"
            v-bind:items="privilege_list"
            v-bind:item-value="(item) => item.privilege_id"
            v-if="is_authen && privilege_id === 91"
            outlined
            dense
          ></v-autocomplete>
        </v-col>
      </v-row>

      <v-row class="px-3">
        <v-col
          v-for="(item, i) in items"
          :key="i"
          v-show="check_permission(item.allow_privilege)"
        >
          <v-card
            class="mx-auto"
            elevation="10"
            color="#f8f9f9"
            width="380"
            min-width="380"
            height="205"
            :href="item.to"
          >
            <div class="image-container">
              <v-img class="align-end zoom-on-hover" :src="item.src"></v-img>
            </div>
            <v-card-title>
              <v-icon left>{{ item.icon }}</v-icon>
              {{ objectTranslator(item, "title") }}
            </v-card-title>
            <v-card-subtitle>
              {{ objectTranslator(item, "sub_title") }}
            </v-card-subtitle>
            <div class="text-right open-in-new">
              <v-icon>mdi-open-in-new</v-icon>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-card-text>

    <v-btn fab class="home-button" @click="goHome">
      <v-icon>mdi-home</v-icon>
    </v-btn>
  </v-card>
</template>

<script>
import { objectTranslator, inlineTranslator } from "@/helper/translator";
export default {
  name: "MainMenu",
  data: () => ({
    privilege_id_test: null,
    privilege_id: null,
    is_authen: false,
    md_title: 6,
    items: [
      {
        title_TH: "หน้าหลักผู้ใช้งาน",
        title_EN: "User Home Page",
        sub_title_TH: "",
        sub_title_EN: "",
        icon: "mdi-home-account",
        src: "images/main_menu/home.png",
        to: `https://www.reg.kmitl.ac.th`, // หน้าหลักผู้ใช้งานตามสิทธิ์
        allow_privilege: [],
      },
      {
        title_TH: "ระบบสารสนเทศนักศึกษา ป.ตรี",
        title_EN: "Student system",
        sub_title_TH: "ข้อมูลผลการเรียน/ขอทำบัตร นศ.ใหม่",
        sub_title_EN:
          "Academic results information/Request for new student ID card",
        icon: "mdi-account-circle",
        src: "images/main_menu/student.png",
        to: `https://www.reg.kmitl.ac.th/index?f=u_student`,
        allow_privilege: [91, 80],
      },
      {
        title_TH: "ระบบสารสนเทศนักศึกษา บัณฑิตศึกษา",
        title_EN: "Student system",
        sub_title_TH: "ข้อมูลผลการเรียน/ขอทำบัตร นศ.ใหม่",
        sub_title_EN:
          "Academic results information/Request for new student ID card",
        icon: "mdi-account-circle",
        src: "images/main_menu/student.png",
        to: `https://www.reg.kmitl.ac.th/index?f=u_student_x`,
        allow_privilege: [91, 85],
      },
      {
        title_TH: "Digital Transcript",
        title_EN: "Digital Transcript",
        sub_title_TH: "ขอทรานสคริปต์ในรูปแบบอิเล็กทรอนิกส์",
        sub_title_EN: "Request Digital Transcript",
        icon: "mdi-file-certificate",
        src: "images/main_menu/digital_transcript.png",
        to: `https://dd.reg.kmitl.ac.th/#/home`,
        allow_privilege: [91, 80, 85, 40, 45],
      },
      {
        title_TH: "ระบบบริการหน้าเคาน์เตอร์ KRESO",
        title_EN: "KRESO counter service system",
        sub_title_TH: "บริการหน้าเคาน์เตอร์",
        sub_title_EN: "Counter service",
        icon: "mdi-account-heart",
        src: "images/main_menu/reg_officer.png",
        to: `https://www.reg.kmitl.ac.th/index?f=u_counter`,
        allow_privilege: [91, 40, 45, 18],
      },
      {
        title_TH: "IT Support",
        title_EN: "IT Support",
        sub_title_TH: "แจ้งงานฝ่าย IT",
        sub_title_EN: "แจ้งงานฝ่าย IT",
        icon: "mdi-wrench",
        src: "images/main_menu/IT_support.png",
        to: `https://ticket.reg.kmitl.ac.th/`,
        allow_privilege: [91, 40, 45, 30],
      },
      {
        title_TH: "ระบบเจ้าหน้าที่ ระดับปริญญาตรี",
        title_EN: "ระบบเจ้าหน้าที่ ระดับปริญญาตรี",
        sub_title_TH: "",
        sub_title_EN: "",
        icon: "mdi-account-heart",
        src: "images/main_menu/bachelor_officer.png",
        to: `https://www.reg.kmitl.ac.th/index?f=u_officer`,
        allow_privilege: [91, 40, 45],
      },
      {
        title_TH: "ระบบเจ้าหน้าที่ ระดับบัณฑิตศึกษา",
        title_EN: "ระบบเจ้าหน้าที่ ระดับบัณฑิตศึกษา",
        sub_title_TH: "",
        sub_title_EN: "",
        icon: "mdi-account-heart",
        src: "images/main_menu/graduate_officer.png",
        to: `https://www.reg.kmitl.ac.th/index?f=u_officer_x`,
        allow_privilege: [91, 40, 45],
      },
      {
        title_TH: "ระบบสารสนเทศเจ้าหน้าที่การเงิน",
        title_EN: "ระบบสารสนเทศเจ้าหน้าที่การเงิน",
        sub_title_TH: "",
        sub_title_EN: "",
        icon: "mdi-cash-multiple",
        src: "images/main_menu/finance.png",
        to: `https://www.reg.kmitl.ac.th/index?f=u_finance`,
        allow_privilege: [91, 30],
      },
      {
        title_TH: "ระบบสารสนเทศเจ้าหน้าที่การเงิน",
        title_EN: "ระบบสารสนเทศเจ้าหน้าที่การเงิน",
        sub_title_TH: "Payment gateway",
        sub_title_EN: "Payment gateway",
        icon: "mdi-cash-multiple",
        src: "images/main_menu/payment.png",
        to: "https://payment.reg.kmitl.ac.th/",
        allow_privilege: [91, 30],
      },
      {
        title_TH: "ระบบสารสนเทศเจ้าหน้าที่คณะ",
        title_EN: "ระบบสารสนเทศเจ้าหน้าที่คณะ",
        sub_title_TH: "",
        sub_title_EN: "",
        icon: "mdi-account-star",
        src: "images/main_menu/external_officer.png",
        to: `https://www.reg.kmitl.ac.th/index?f=u_cregis`,
        allow_privilege: [91, 40, 45, 10],
      },
      {
        title_TH: "สวมสิทธิ์ ระบบเดิม",
        title_EN: "สวมสิทธิ์ ระบบเดิม",
        sub_title_TH: "",
        sub_title_EN: "",
        icon: "mdi-account-heart",
        src: "images/main_menu/impersonation.png",
        to: `https://www.reg.kmitl.ac.th/index?f=tester`,
        allow_privilege: [91],
      },
      {
        title_TH: "ระบบลงทะเบียนเรียน",
        title_EN: "Registration System",
        sub_title_TH: "ลงทะเบียนเรียน และเพิ่ม/เปลี่ยน/ถอนรายวิชา",
        sub_title_EN: "Registration/ Add/ Change/ Withdraw courses",
        icon: "mdi-gesture-double-tap",
        src: "images/main_menu/registration.png",
        to: "https://regis.reg.kmitl.ac.th/#/",
        allow_privilege: [91, 10, 80, 85],
      },
      {
        title_TH: "ระบบสารสนเทศอาจารย์",
        title_EN: "Lecturer system",
        sub_title_TH: "บันทึกผลการเรียนของนักศึกษา / ส่งรายงานฉบับสมบูรณ์",
        sub_title_EN: "Record student performance / Submit complete report",
        icon: "mdi-account-tie",
        src: "images/main_menu/lecturer.png",
        to: `https://www.reg.kmitl.ac.th/index?f=u_teacher_v20`,
        allow_privilege: [91, 60],
      },
      {
        title_TH: "ระบบส่งผลการศึกษา",
        title_EN: "Educational submission system",
        sub_title_TH: "ติดตาม/ตรวจสอบ/อนุมัติ การประกาศผลการศึกษา",
        sub_title_EN:
          "Track/check/approve the announcement of academic results",
        icon: "mdi-account-switch",
        src: "images/main_menu/approve_grade.png",
        to: "https://grade-approval.reg.kmitl.ac.th/",
        allow_privilege: [91, 60, 40, 45, 10, 19],
      },
      {
        title_TH: "สจล.1",
        title_EN: "KMITL-1",
        sub_title_TH: "ข้อมูลประวัตินักศึกษา",
        sub_title_EN: "Student information",
        icon: "mdi-account-check",
        src: "images/main_menu/kmitl1.png",
        to: "https://kmitl1.reg.kmitl.ac.th/#/kmitl1",
        allow_privilege: [91, 60, 40, 45, 10, 80, 85, 55],
      },
      {
        title_TH: "ปฏิทินการศึกษา",
        title_EN: "Academic Calendar",
        sub_title_TH: "ปฏิทินกิจกรรมการศึกษา",
        sub_title_EN: "Academic Activities Calendar",
        icon: "mdi-calendar-month",
        src: "images/main_menu/calendar.png",
        to: `https://www.reg.kmitl.ac.th/index?f=educalendar`,
        allow_privilege: [],
      },
      {
        title_TH: "ระบบตารางเรียน - สอบ",
        title_EN: "Timetable - Exam Schedule",
        sub_title_TH: "ข้อมูลการเปิดสอนของรายวิชาในแต่ละปีการศึกษา",
        sub_title_EN:
          "Information on the teaching of subjects in each academic year",
        icon: "mdi-table-of-contents",
        src: "images/main_menu/timetable.png",
        to: "https://regis.reg.kmitl.ac.th/#/teach_table_selector",
        allow_privilege: [],
      },
      {
        title_TH: "ระบบรับสมัครเข้าศึกษา",
        title_EN: "Admission system",
        sub_title_TH: "",
        sub_title_EN: "",
        icon: "mdi-account-outline",
        src: "images/main_menu/admission.png",
        to: "https://admission.reg.kmitl.ac.th/",
        allow_privilege: [],
      },
      {
        title_TH: "ระบบรายงานตัวนักศึกษาใหม่",
        title_EN: "Matriculation System",
        sub_title_TH: "สำหรับนักศึกษาใหม่กรอกข้อมูลประวัติ สจล.1",
        sub_title_EN:
          "For new students, fill in the KMITL-1 student information.",
        icon: "mdi-account-check",
        src: "images/main_menu/matriculation.png",
        to: "https://kmitl1.reg.kmitl.ac.th/",
        allow_privilege: [91, 40, 45],
      },
    ],
    privilege_list: [
      {
        privilege_id: 91,
        name: "IT ADMIN",
        key: "PRIV_ADMIN",
      },
      {
        privilege_id: 80,
        name: "Bachelor Student",
        key: "PRIV_STUDENT",
      },
      {
        privilege_id: 85,
        name: "Graduate Student",
        key: "PRIV_STUDENT_X",
      },
      {
        privilege_id: 60,
        name: "Lecturer",
        key: "PRIV_TEACHER",
      },
      {
        privilege_id: 40,
        name: "เจ้าหน้าที่ - สำนักทะเบียน (ป.ตรี)",
        key: "PRIV_OFFICER",
      },
      {
        privilege_id: 45,
        name: "เจ้าหน้าที่ - สำนักทะเบียน (บัณฑิต)",
        key: "PRIV_OFFICER_X",
      },
      {
        privilege_id: 30,
        name: "เจ้าหน้าที่ - การเงิน",
        key: "PRIV_FINANCE",
      },
      {
        privilege_id: 10,
        name: "เจ้าหน้าที่ - คณะ",
        key: "PRIV_CREG",
      },
      {
        privilege_id: 19,
        name: "เจ้าหน้าที่ - GENED",
        key: "PRIV_GENED",
      },
      {
        privilege_id: 25,
        name: "เจ้าหน้าที่ - หอสมุด",
        key: "PRIV_LIB",
      },
      {
        privilege_id: 22,
        name: "เจ้าหน้าที่ - ภาระงานสอน",
        key: "PRIV_TEACHING",
      },
      {
        privilege_id: 23,
        name: "เจ้าหน้าที่ - HR",
        key: "PRIV_HR",
      },
      {
        privilege_id: 35,
        name: "เจ้าหน้าที่ - กองกิจ",
        key: "PRIV_SAFFAIR",
      },
      {
        privilege_id: 36,
        name: "เจ้าหน้าที่ - หลักสูตร",
        key: "PRIV_ACADEMIC",
      },
      {
        privilege_id: 41,
        name: "เจ้าหน้าที่ - งานบุคคล",
        key: "PRIV_PERSON",
      },
      {
        privilege_id: 55,
        name: "เจ้าหน้าที่ - งานทุน",
        key: "PRIV_SCHOLAR",
      },
      {
        privilege_id: 15,
        name: "เจ้าหน้าที่ - งานแผน",
        key: "PRIV_PLAN",
      },
      {
        privilege_id: 18,
        name: "เจ้าหน้าที่ - งานเคาน์เตอร์",
        key: "PRIV_COUNTER",
      },
    ],
  }),
  computed: {
    privilege_name() {
      const privilege = this.privilege_list.find(
        (item) => item.privilege_id === this.privilege_id
      );
      return privilege ? privilege.name : "Unknown";
    },
  },
  watch: {
    privilege_id_test: function (val) {
      let key = null;
      const data = this.privilege_list.find(
        (item) => item.privilege_id === val
      );
      if (data) {
        key = data.key;
        this.items[0].to = this.getHomePage(key);
      }
    },
  },
  methods: {
    objectTranslator,
    inlineTranslator,
    fetch_data() {
      this.privilege_id_test = this.privilege_id;
      if (this.privilege_id == 91) {
        this.md_title = 3;
      }
    },
    check_permission(list) {
      if (list.length === 0) {
        return true;
      } else if (list.includes(this.privilege_id_test)) {
        return true;
      } else {
        return false;
      }
    },
    getHomePage(case_id) {
      let url = `https://www${
        process.env.VUE_APP_ENV !== "production" ? "-staff" : ""
      }.reg.kmitl.ac.th`;
      switch (case_id) {
        case "PRIV_CREG":
          url = url.concat("/index?f=u_cregis");
          break;
        case "PRIV_PLAN":
          url = url.concat("/index?f=u_plan");
          break;
        case "PRIV_LIB":
          url = url.concat("/index?f=u_lib");
          break;
        case "PRIV_FINANCE":
          url = url.concat("/index?f=u_finance&p=finance.php");
          break;
        case "PRIV_SAFFAIR":
          url = url.concat("/index?f=u_saffair");
          break;
        case "PRIV_OFFICER":
          url = url.concat("/index?f=u_officer");
          break;
        case "PRIV_OFFICER_X":
          url = url.concat("/index?f=u_officer_x");
          break;
        case "PRIV_TEACHER":
          url = url.concat("/index?f=u_teacher_v20");
          break;
        case "PRIV_STUDENT":
          url = url.concat("/index?f=u_student");
          break;
        case "PRIV_STUDENT_X":
          url = url.concat("/index?f=u_student_x");
          break;
        case "PRIV_ACADEMIC":
          url = url.concat("/index?f=u_academic");
          break;
        case "PRIV_SCHOLAR":
          url = url.concat("/index?f=u_scholar");
          break;
        case "PRIV_PERSON":
          url = url.concat("/index?f=persononline");
          break;
        case "PRIV_GENED":
          url = url.concat("/index?f=u_gened");
          break;
        case "PRIV_TEACHING":
        case "PRIV_HR":
          url = url.concat("/index?f=u_teaching");
          break;
        case "PRIV_COUNTER":
          url = url.concat("/index?f=u_counter");
          break;
        default:
          url = url.concat("/index.php");
          break;
      }

      return url;
    },
    goHome() {
      window.location.href = "https://www.reg.kmitl.ac.th/index/";
    },
  },
  created() {
    this.privilege_id =
      this.$store.state.user.user_info.payload.ticket.privilege;
    this.is_authen = this.$store.state.user.is_authen;
    this.fetch_data();
  },
};
</script>

<style scoped>
.home {
  text-align: center;
  padding: 2rem;
}

.home-button {
  position: fixed;
  top: 130px;
  right: 60px;
  background-color: rgb(255, 255, 255);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
  z-index: 9999;
}

.home-button .v-icon {
  font-size: 30px !important; /* Override Vuetify's default size */
}

.open-in-new {
  position: absolute;
  right: 15px;
  bottom: 15px;
}

.image-container {
  overflow: hidden;
  display: inline-block;
  height: 110px;
  width: 100%;
}

.zoom-on-hover {
  transition: transform 0.2s ease-in-out;
}

.zoom-on-hover:hover {
  transform: scale(1.05);
}
</style>
